import { useEffect, useState } from "react";
import axios from "axios";
import { MessageSquareText, Plus, Save, Trash2 } from "lucide-react";
import { API } from "../lib/apiClient";
import { loadTemplates, setTemplatesCache } from "./WaTemplatePicker";

export function WaTemplatesCard() {
  const [list, setList] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { loadTemplates(true).then(setList).catch(() => setList([])); }, []);
  const patch = (i, k, v) => setList((l) => l.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  const save = async () => {
    setBusy(true); setMsg("");
    try {
      const { data } = await axios.put(`${API}/wa-templates`, { templates: list.map(({ id, name, text }) => (id ? { id, name, text } : { name, text })) });
      setList(data); setTemplatesCache(data); setMsg("Şablonlar kaydedildi.");
    } catch (e) { setMsg(e?.response?.data?.detail || "Kaydedilemedi"); } finally { setBusy(false); }
  };
  return (
    <section className="panel settings-card" data-testid="wa-templates-card">
      <div className="settings-card-head"><MessageSquareText size={16} /> <h2>Hazır WhatsApp şablonları</h2></div>
      <p className="privacy-note">Randevu kartındaki WhatsApp düğmesinde listelenir. Kullanılabilir alanlar: <code>{"{ad}"}</code> <code>{"{tarih}"}</code> <code>{"{saat}"}</code> <code>{"{konu}"}</code></p>
      {list && (
        <div className="wa-tpl-list">
          {list.map((t, i) => (
            <div key={t.id || `new-${i}`} className="wa-tpl-item" data-testid={`wa-tpl-item-${i}`}>
              <input value={t.name} onChange={(e) => patch(i, "name", e.target.value)} placeholder="Şablon adı" data-testid={`wa-tpl-name-${i}`} />
              <textarea rows="2" value={t.text} onChange={(e) => patch(i, "text", e.target.value)} placeholder="Mesaj metni" data-testid={`wa-tpl-text-${i}`} />
              <button type="button" className="icon-button" onClick={() => setList((l) => l.filter((_, j) => j !== i))} title="Sil" data-testid={`wa-tpl-delete-${i}`}><Trash2 size={15} /></button>
            </div>
          ))}
        </div>
      )}
      <div className="settings-actions">
        <button type="button" className="outline-button" onClick={() => setList((l) => [...(l || []), { name: "", text: "" }])} data-testid="wa-tpl-add"><Plus size={14} /> Yeni şablon</button>
        <button type="button" className="primary-button" onClick={save} disabled={busy || !list} data-testid="wa-tpl-save"><Save size={14} /> Kaydet</button>
      </div>
      {msg && <small className="signature-hint" data-testid="wa-tpl-msg">{msg}</small>}
    </section>
  );
}
